import { IHypercortisolaemiaPasireotide } from './HypercortisolaemiaPasireotide.types';

export const initialHypercortisolaemiaPasireotide : IHypercortisolaemiaPasireotide= {
  dose: "",
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}